<template>

    <div :class="show ? 'NavAreaPointMoudle show':'NavAreaPointMoudle'" ref="NavAreaPointMoudle">

        <div class="loading" v-if="!NavAreaPoint.point">
            <i class="iconfont icon-loading"></i>
        </div>

        <div class="wrap-box" v-else>

            <div class="name">{{NavAreaPoint.title}}</div>
            <div class="close-box" @click="show = false"><i class="iconfont icon-cha"></i></div>

            <div class="IMG-box">

                <Swipe class="brt-map-qsm-swipe" :options="swipeOptions" v-if="NavAreaPoint.icon">

                    <!--v-for="item in NavAreaPoint.icon"-->
                    <SwipeSlide class="brt-map-qsm-slide">

                        <div class="IMG-box"><img :src="NavAreaPoint.icon" alt="滑动图片" @click = 'slidIMG(item)'></div>

                    </SwipeSlide>

                </Swipe>

            </div>

            <div class="txt-box">{{NavAreaPoint.text}}</div>

        </div>

    </div>

</template>

<script>

    import { Swipe, SwipeSlide } from '@/components/swipe'

    //模拟点位
    // let $NavAreaPoint = [
    //     {
    //         title:'',
    //         icon:['./images/poidetail_slide.jpg'],
    //         text:'我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试',
    //         point:{
    //             CATEGORY_ID:"010100",
    //             CATEGORY_NAME:"中餐厅",
    //             FLOOR_ID:"00270007F01",
    //             FLOOR_NAME:"F1",
    //             FLOOR_NUMBER:1,
    //             LABEL_X:12738430.466525998,
    //             LABEL_Y:3582439.2799499473,
    //             NAME:"商业区",
    //             POI_ID:"00270007F0110228"
    //         },
    //
    //         distant:20
    //     },
    //     {
    //         title:'',
    //         icon:['./images/poidetail_slide.jpg'],
    //         text:'我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试我是测试',
    //         point:{
    //             CATEGORY_ID:"110200",
    //             CATEGORY_NAME:"中餐厅",
    //             FLOOR_ID:"00270007F01",
    //             FLOOR_NAME:"F1",
    //             FLOOR_NUMBER:1,
    //             LABEL_X:12738315.225449998,
    //             LABEL_Y:3582471.7546443306,
    //             NAME:"C1到达区",
    //             POI_ID:"F1JC87"
    //         },
    //
    //         distant:20
    //     }
    // ]

    export default {
        name: "NavAreaPointMoudle",

        created(){

            this.bus.$off('navArea');
            this.bus.$on('navArea',(res)=>{
                //清空数据
                if(res.status && res.status == 1){

                    this.NavAreaPoint = '';
                    this.swipeIndex = 0;
                    this.show = false;

                }else{

                    this.getAreaPoint(res);

                }

            })

        },
        data(){
            return {
                show:false,

                swipeOptions: {
                    continuous: false,
                    disableScroll: true,
                    disableIOSScroll: true,
                    callback: (i) => {
                        this.swipeIndex = i;
                    }
                },
                swipeIndex: 0,

                NavAreaPoint:'',

            }
        },

        methods:{

            getAreaPoint (v1){

                if(v1 && this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){

                    let $NavAreaPoint  = this.$store.state.NAVAREAPOINT_DATA;

                    // console.log('$NavAreaPoint',$NavAreaPoint);
                    // console.log('point',v1);

                    let NavAreaPointRemit=[],point; //缓存做筛查

                    for(let i =0 ;i<$NavAreaPoint.length;i++){

                        let _d = Math.sqrt((v1.x - $NavAreaPoint[i].point.LABEL_X) * (v1.x - $NavAreaPoint[i].point.LABEL_X) + (v1.y - $NavAreaPoint[i].point.LABEL_Y) * (v1.y - $NavAreaPoint[i].point.LABEL_Y));

                        // console.log('_d',_d);

                        if(_d< $NavAreaPoint[i].distant){

                            NavAreaPointRemit.push({data:$NavAreaPoint[i],distant:_d})   //缓存

                        }

                    }

                    //选取最近的点显示
                    if(NavAreaPointRemit.length>0){
                        //距离排序
                        point = NavAreaPointRemit.length == 1 ? NavAreaPointRemit[0] : NavAreaPointRemit.sort((v1,v2)=>{
                            return v1.distant - v2.distant
                        })[0];

                        // console.log('this.NavAreaPoint.point',this.NavAreaPoint.point,'point.data',point.data);
                        //防止被关闭后再次弹出
                        if(!this.NavAreaPoint.point ||(this.NavAreaPoint.point && point.data.point.LABEL_X != this.NavAreaPoint.point.LABEL_X && point.data.point.LABEL_Y != this.NavAreaPoint.point.LABEL_Y)){
                            this.NavAreaPoint = point.data;
                            this.show = true;

                            //防止在一个点位长久站立 30s后再弹出
                            if($tipAgain){clearTimeout($tipAgain)}
                            var $tipAgain = setTimeout(()=>{this.NavAreaPoint = ''},30*1000)
                        }

                    }

                    //过了触发区域隐藏 且无新的触发点
                    if(this.NavAreaPoint.point){
                        let _$d = Math.sqrt((v1.x - this.NavAreaPoint.point.LABEL_X) * (v1.x - this.NavAreaPoint.point.LABEL_X) + (v1.y - this.NavAreaPoint.point.LABEL_Y) * (v1.y - this.NavAreaPoint.point.LABEL_Y));
                        if(NavAreaPointRemit.length == 0 && _$d > this.NavAreaPoint.distant){this.show = false}
                    }

                }
            }

        },

        watch:{
            // locate(v1,v2){
            //     if(v1 && this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){
            //
            //         let $NavAreaPoint  = this.$store.state.NAVAREAPOINT_DATA;
            //
            //         console.log('$NavAreaPoint',$NavAreaPoint);
            //
            //         let NavAreaPointRemit=[],point; //缓存做筛查
            //
            //         for(let i =0 ;i<$NavAreaPoint.length;i++){
            //
            //             let _d = Math.sqrt((v1.x - $NavAreaPoint[i].point.LABEL_X) * (v1.x - $NavAreaPoint[i].point.LABEL_X) + (v1.y - $NavAreaPoint[i].point.LABEL_Y) * (v1.y - $NavAreaPoint[i].point.LABEL_Y));
            //
            //             if(_d< $NavAreaPoint[i].distant){
            //
            //                 NavAreaPointRemit.push({data:$NavAreaPoint[i],distant:_d})   //缓存
            //
            //             }
            //
            //         }
            //
            //         //选取最近的点显示
            //         if(NavAreaPointRemit.length>0){
            //             point = NavAreaPointRemit.length == 1 ? NavAreaPointRemit[0] : NavAreaPointRemit.sort((v1,v2)=>{
            //                 return v1.distant - v2.distant
            //             })[0];
            //
            //
            //             //防止被关闭后再次弹出
            //             if(!this.NavAreaPoint.point ||(this.NavAreaPoint.point && point.data.LABEL_X != this.NavAreaPoint.point.LABEL_X && point.data.LABEL_Y != this.NavAreaPoint.point.LABEL_Y)){
            //                 this.NavAreaPoint = point.data;
            //                 this.show = true;
            //             }
            //
            //         }
            //
            //         //过了触发区域隐藏 且无新的触发点
            //         if(this.NavAreaPoint.point){
            //             let _$d = Math.sqrt((v1.x - this.NavAreaPoint.point.LABEL_X) * (v1.x - this.NavAreaPoint.point.LABEL_X) + (v1.y - this.NavAreaPoint.point.LABEL_Y) * (v1.y - this.NavAreaPoint.point.LABEL_Y));
            //             if(NavAreaPointRemit.length == 0 && _$d > this.NavAreaPoint.distant){this.show = false}
            //         }
            //
            //     }
            // },

            // testpoint(v1,v2){
            //
            //     if(v1 && this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){
            //
            //         let $NavAreaPoint  = this.$store.state.NAVAREAPOINT_DATA;
            //
            //         let NavAreaPointRemit=[],point; //缓存做筛查
            //
            //         for(let i =0 ;i<$NavAreaPoint.length;i++){
            //
            //             let _d = Math.sqrt((v1.x - $NavAreaPoint[i].point.LABEL_X) * (v1.x - $NavAreaPoint[i].point.LABEL_X) + (v1.y - $NavAreaPoint[i].point.LABEL_Y) * (v1.y - $NavAreaPoint[i].point.LABEL_Y));
            //
            //             if(_d< $NavAreaPoint[i].distant){
            //
            //                 NavAreaPointRemit.push({data:$NavAreaPoint[i],distant:_d})   //缓存
            //
            //             }
            //
            //         }
            //
            //         //选取最近的点显示
            //         if(NavAreaPointRemit.length>0){
            //             point = NavAreaPointRemit.length == 1 ? NavAreaPointRemit[0] : NavAreaPointRemit.sort((v1,v2)=>{
            //                 return v1.distant - v2.distant
            //             })[0];
            //
            //                //防止被关闭后再次弹出
            //                if(!this.NavAreaPoint.point ||(this.NavAreaPoint.point && point.data.LABEL_X != this.NavAreaPoint.point.LABEL_X && point.data.LABEL_Y != this.NavAreaPoint.point.LABEL_Y)){
            //                    this.NavAreaPoint = point.data;
            //                    this.show = true;
            //                }
            //         }
            //
            //         //过了触发区域隐藏 且无新的触发点
            //         if(this.NavAreaPoint.point){
            //             let _$d = Math.sqrt((v1.x - this.NavAreaPoint.point.LABEL_X) * (v1.x - this.NavAreaPoint.point.LABEL_X) + (v1.y - this.NavAreaPoint.point.LABEL_Y) * (v1.y - this.NavAreaPoint.point.LABEL_Y));
            //             if(NavAreaPointRemit.length == 0 && _$d > this.NavAreaPoint.distant){this.show = false}
            //         }
            //
            //     }
            // },
        },

        computed:{

            // locate(){
            //     return this.$store.state.mapStore.brtmap.$locate.point;
            // },

            // testpoint(){
            //     return this.$BRT.$NAVTO.testPoint;
            // },
        },

        components: {
            Swipe,
            SwipeSlide
        },

    }
</script>

<style lang="less">

    @import "NavAreaPointMoudle.less";

</style>
